module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="icon"></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/user/SignInNavBarView.tpl
// module id = 2809
// module chunks = 0